export async function syncfusion_dropdownlist(fieldId: string, placeholder: string, data: { [key: string]: Object }[], hasError: boolean, showClearButton: boolean = true) {

    await import('@syncfusion/ej2-base/styles/bootstrap4.css');
    await import('@syncfusion/ej2-buttons/styles/bootstrap4.css');
    await import('@syncfusion/ej2-inputs/styles/bootstrap4.css');
    await import('@syncfusion/ej2-popups/styles/bootstrap4.css');
    await import('@syncfusion/ej2-lists/styles/bootstrap4.css');
    await import('@syncfusion/ej2-dropdowns/styles/bootstrap4.css');

    await import('./loadSyncfusion');

    const { DropDownList } = await import('@syncfusion/ej2-dropdowns');

    const containerEle = document.getElementById('container_' + fieldId) as HTMLElement;
    const inputEle = document.getElementById('input_' + fieldId);

    const dataEle = document.getElementById('data_' + fieldId);
    if (dataEle.hasAttribute("data-dropdownlist")) {
        (inputEle.parentNode as HTMLElement).classList.toggle('e-error', hasError);
        return;
    }

    dataEle.setAttribute('data-dropdownlist', 'true');
    const dataEleVal = dataEle.getAttribute('value');

    let ddObject = new DropDownList({
        // sets the placeholder
        floatLabelType: "Never",
        placeholder: null,
        showClearButton: showClearButton,
        dataSource: data,
        fields: { text: 'Text', value: 'Value', groupBy: 'Group' },
        value: dataEleVal,
        change: (args: any) => {
            if (typeof (ddObject.value) === "undefined") {
                return;
            }

            dataEle.setAttribute('value', ddObject.value?.toString());
            dataEle.dispatchEvent(new Event('change'));
            //(inputEle.closest("form").querySelector("button[type=submit]") as HTMLButtonElement).click();
        },
        created: (args: any) => {
            (inputEle.parentNode as HTMLElement).classList.toggle('e-error', hasError);
            //containerEle.style.display = null;
        }
    });
    ddObject.appendTo('#input_' + fieldId);

    containerEle.onclick = () => ddObject.showPopup();
}
